module.exports = __webpack_public_path__ + "media/career-areas-mobile@sm-27dd51c664daee6fc4a5315633a5dcf0.png";